(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

// comment for eslint

/* global FormData */
import snakeCase from "just-snake-case";
export default function snakelizeKeys(object) {
  if (!object || object instanceof Date || object instanceof FormData || typeof object !== "object") {
    return object;
  }

  if (Array.isArray(object)) {
    return object.map(element => snakelizeKeys(element));
  }

  return Object.keys(object).reduce((result, fieldName) => {
    const snakeKey = snakeCase(fieldName);

    if (snakeKey && snakeKey in result) {
      throw new Error("Snakecased key ".concat(snakeKey, " would overwrite existing key of the given object"));
    }

    return { ...result,
      [snakeKey]: snakelizeKeys(object[fieldName])
    };
  }, {});
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(snakelizeKeys, "snakelizeKeys", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/snakelizeKeys.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();